import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const Language = ({ title = 'Translation', ...rest }: IconProps) => {
  return (
    <BaseSvg viewBox="0 0 16 16" title={title} {...rest}>
      <g fill="currentColor">
        <path d="M7.548,9.55l.634-1.805a8.59,8.59,0,0,1-1.875-.828A7.423,7.423,0,0,0,7.416,5.3,7.865,7.865,0,0,0,8.1,3.369c.589,0,.979.02,1.419.06V1.62a12.226,12.226,0,0,1-1.45.07H5.687V1.08a3.078,3.078,0,0,1,.06-.61H3.738a3.034,3.034,0,0,1,.06.62v.6H1.589A12.321,12.321,0,0,1,.14,1.62V3.429c.5-.04.839-.06,1.429-.06a8.8,8.8,0,0,0,.69,1.709A8.7,8.7,0,0,0,3.548,6.907,10.892,10.892,0,0,1,0,8.216,5.793,5.793,0,0,1,.959,9.985,12.816,12.816,0,0,0,4.938,8.146,11.581,11.581,0,0,0,7.548,9.55ZM3.488,3.369H6.137a5.635,5.635,0,0,1-1.25,2.418A5.7,5.7,0,0,1,3.488,3.369Z" />
        <path
          d="M13.717,16l-.725-2.379H9.349L8.624,16H6.341L9.868,5.965h2.591L16,16Zm-1.231-4.156q-1-3.234-1.131-3.657c-.084-.283-.145-.506-.181-.67q-.226.874-1.292,4.327Z"
          fill="currentColor"
        />
      </g>
    </BaseSvg>
  )
}

Language.displayName = 'Language'

export default Language
